module.exports = __webpack_public_path__ + "img/rtf.c655c831.svg";